import omit from 'lodash/omit';
import isNumber from 'lodash/isNumber';
import TextField from '@mui/material/TextField';
import CustomInput from './CustomInput';

const handleChange = ({onChange, step}) => e => {
  const parsed = (
    ['1', 1].includes(step)
    ? parseInt(e.target.value, 10)
    : parseFloat(e.target.value)
  );
  // an empty/partial input (e.g. '', '-') parses to NaN; treat that as no value
  // rather than letting NaN propagate into state
  onChange({target: {value: Number.isNaN(parsed) ? '' : parsed}});
};

const formatNumber = (value, {isCurrency = false} = {})  => {
  return value;
};

const CustomNumberField = props => {
  const {step, onChange} = props;
  const InputProps = {
    inputProps: {
      type: 'number',
      min: isNumber(props.min) ? props.min : null,
      max: isNumber(props.max) ? props.max : null,
      step: props.isCurrency ?  '0.01' : (props.step || null),
      maxlength: props.maxlength || props.maxLength || null,
      fullWidth: props.fullWidth
    }
  };
  return (
    <CustomInput {...omit(props, 'children')}>
      <TextField
        type='number'
        style={{
          ...(props.style || {}),
          backgroundColor: 'white',
        }}
        sx={{...(props.sx || {})}}
        InputProps={InputProps}
        {...omit(props, 'helperText', 'label', 'style', 'sx')}
        onChange={handleChange({onChange, step: step || (props.isCurrency ? '0.01' : '1')})}
      />
    </CustomInput>
  );
};

export default CustomNumberField;
